import axios from 'axios';

// ใช้ environment variable สำหรับ API URL
// ใน development: VITE_API_URL=http://localhost:8000/api
// ใน production: VITE_API_URL=https://your-domain.com/api
// ถ้าไม่ระบุจะใช้ relative path /api (สำหรับ deploy ใน Laravel public)
const apiBaseURL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
    baseURL: apiBaseURL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true // For Sanctum cookie-based auth if used, or just to handle cookies
});

// Add interceptor to include token if available (for member/admin)
api.interceptors.request.use(config => {
    // Check if it's an admin request
    if (config.url.startsWith('/admin') && !config.url.includes('/login')) {
        const adminToken = localStorage.getItem('admin_token');
        if (adminToken) {
            config.headers.Authorization = `Bearer ${adminToken}`;
        }
    } else {
        // Member/Public requests
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    
    // Add Session ID for guest cart
    const sessionId = localStorage.getItem('session_id');
    if (sessionId) {
        config.headers['X-Session-ID'] = sessionId;
    }

    return config;
});

export default api;
